import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "mdbreact/dist/css/mdb.css";
import { MDBCard, MDBCardBody, MDBCardTitle } from "mdbreact";

import Slider from "./Slider";
import HomeCardDeck from "./HomeCardDeck";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: true,
    };
  }

  render() {
    return (
      <div
      className="cardeck_full"
      
    >
      <div
      className="carddeck_inner"
        style={{
          // paddingTop: "0px",
          // paddingRight: "10px",
          // paddingBottom: "10px",
          // paddingLeft: "10px",
          backgroundColor: "#f0f5ff",
        }}
      >
         

          <Slider />
          <HomeCardDeck />
          {/* <MDBCol md="4" key={key} style={{margin:"2px"}}>
        
         </MDBCol> */}
        </div>
      </div>
    );
  }
}

export default Home;
